// @ts-nocheck
type LayerType = 'layer' | 'index' | 'venuesLayer' | 'screensLayer' | 'locationsLayer' | 'screensGroupsLayer';

export const MAP_STYLE_CODE_FONT: Record<string, any> = {
  default: 'Font Awesome 6 Pro Regular',
  fa: 'Font Awesome 6 Pro Regular',
  fak: 'Font Awesome Kit Regular',
  fal: 'Font Awesome 6 Pro Light',
  far: 'Font Awesome 6 Pro Regular',
  fas: 'Font Awesome 6 Pro Solid'
};

export const getUnicodeFromIcon = (iconClassName: string) => {
  const iconName = iconClassName.slice(iconClassName.lastIndexOf('fa-') + 3);
  const unicode: Record<string, string> = {
    // Config
    alicorn: 'f6b0',
    // DefaultIcons
    apartment: 'e468',
    'bags-shopping': 'f290',
    briefcase: 'f0b1',
    burger: 'f805',
    'burger-soda': 'f858',
    car: 'f1b9',
    cog: 'f013',
    coins: 'f51e',
    desktop: 'f390',
    // Layers
    'draw-polygon': 'f5ee',
    'empty-set': 'f656',
    exclamation: '21',
    'game-console-handheld': 'f8bb',
    'gas-pump': 'f52f',
    'graduation-cap': 'f19d',
    guitars: 'f8bf',
    'hands-praying': 'f684',
    heart: 'f004',
    home: 'f015', // fa-house
    'house-chimney-window': 'e00d',
    info: 'f129',
    leaf: 'f06c',
    'location-arrow': 'f124',
    'location-dot': 'f3c5',
    'map-signs': 'f277', // fa-signs-post
    mars: 'f222',
    newspaper: 'f1ea',
    paw: 'f1b0',
    'plane-departure': 'f5b0',
    plus: '2b',
    'scale-balanced': 'f24e',
    'screen-dooh': 'e00d',
    sign: 'f4d9', // fa-sign-hanging
    star: 'f005',
    store: 'f54e',
    'tennis-ball': 'f45e',
    tshirt: 'f553',
    'user-group': 'f500',
    'utensils-alt': 'f2e6',
    venus: 'f221'
  };

  return String.fromCharCode(Number(`0x${unicode[iconName]}`));
};

export const getFontAwesomeIcon = (layerIcon: string, originalLayerType: LayerType) => {
  let tempIcon = '';
  if (layerIcon) {
    tempIcon = layerIcon.includes('fa-') ? layerIcon : `fa-${layerIcon}`;
  } else {
    switch (originalLayerType) {
      case 'venuesLayer':
        tempIcon = 'fa-location-dot';
        break;
      case 'screensLayer':
        tempIcon = 'fa-screen-dooh';
        break;
      default:
        tempIcon = 'fa-star';
        break;
    }
  }

  return getUnicodeFromIcon(tempIcon);
};

export const getFontAwesomeStyleCode = (layerIcon: string) => {
  const styleList = layerIcon.split(' ');
  return styleList.length === 2 ? styleList[0] : 'fal';
};

export const COUNTRY_LEVEL_CODE = 'level0';
